import { render, staticRenderFns } from "./donut-graph.vue?vue&type=template&id=06c97bbb&scoped=true"
import script from "./donut-graph.vue?vue&type=script&lang=js"
export * from "./donut-graph.vue?vue&type=script&lang=js"
import style0 from "./donut-graph.vue?vue&type=style&index=0&id=06c97bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c97bbb",
  null
  
)

export default component.exports